module.exports = __webpack_public_path__ + "img/farzana-christopher-157.687e89ab.jpg";